var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('comHeader',{staticStyle:{"height":"80px"}}),_vm._v(" "),_c('el-main',{staticStyle:{"width":"100%","overflow-x":"hidden"}},[_c('router-view')],1),_vm._v(" "),_c('el-footer',[_c('comFooter')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27edffdb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/V3/Index.vue
// module id = null
// module chunks = 